<template>
  <div class="cell">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-card v-for="item in list" :key="item.isbn" :price="item.now_price" :title="item.book_name"
          :desc="'购买数量：' + item.buy_num +  '   销量：' + item.sold_num" 
        :thumb="item.image_url" @click="openUrl(item.isbn, item.dzy_id)" :origin-price="item.all_amount">
        <div slot="footer">
          <van-button round type="info" v-for="item_ids in item.ids" :key="item_ids.dzy_id" size="mini" @click.stop="duozhuayu(item_ids.dzy_id)">查看多抓鱼{{item_ids.to_buy?"":"=>"+item_ids.not_buy_type }}</van-button>
          <van-button round type="danger" size="normal" @click.stop="editPrice(item.isbn)">移出</van-button>
        </div>
        <div slot="tags">
          <van-tag v-if="item.remark2" type="warning"> 备注：{{ item.remark2 }} </van-tag>
        </div>
      </van-card>
    </van-pull-refresh>
  </div>
</template>
<script>
export default {
  data () {
    return {
      waitting: '',
      read: '',
      uuid: '',
      active: 0,
      unReadNum: 0,
      waittingNum: 0,
      isLoading: false,
      members: [],
      list: [],
      value: ''
    }
  },
  created () {
    this.getAccoutList()
  },
  methods: {
    duozhuayu(dzy_id) {
      window.open('https://www.duozhuayu.com/books/' + dzy_id, '_blank')
    },
    openUrl (isbn, dzy_id) {
      this.$router.push({
        path: '/notbook',
        query: {
          isbn: isbn,
          dzyid: dzy_id,
        }
      })
    },
    async getAccoutList () {
      const { data: res } = await this.$http.get('outOfPrintBook/list?need_edit_price=1')
      this.list = res.data
    },
    async editPrice (isbn) {
      console.log(isbn)
      const { data: res } = await this.$http.get('outOfPrintBook/editPrice?isbn=' + isbn)
      this.getAccoutList()
    },
    onRefresh () {
      this.list =[]
      this.isLoading = true
      this.getAccoutList()
      this.isLoading = false
    }
  }
}
</script>
<style lang="less" scoped>
.chatList {
  margin-top: 15px;
}

.cell {
  padding-top: 10px;
  background: #fff;

  .item {
    display: flex;
    font-size: 12px;
    padding: 10px 6px;
    border-bottom: 1px solid #eee;
    margin-bottom: 6px;

    .left {
      width: 46px;
      height: 46px;
      margin-right: 6px;

      ::v-deep .van-image {
        width: 100%;
        height: 100%;
      }
    }

    .right {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .top {
        display: flex;
        justify-content: space-between;

        span {
          &:first-child {
            font-size: 14px;
          }
        }
      }

      .bottom {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: calc(100vw - 150px);
        color: #999;
      }
    }
  }
}
</style>
